import {createTheme} from '@mui/material/styles';

export const getTheme = (darkMode) => {
    const palette = {
        mode: darkMode ? 'dark' : 'light',
        primary: {
            main: darkMode ? '#82B1FF' : '#2962FF',
            contrastText: darkMode ? '#0D1330' : '#FFFFFF',
        },
        secondary: {
            // Change to harmonious blue instead of turquoise
            main: darkMode ? '#5C6BC0' : '#3F51B5',
            contrastText: darkMode ? '#FFFFFF' : '#FFFFFF',
        },
        // Gamification colors - harmonious blue-based palette
        gamification: {
            // Main blue family - consistent with primary theme
            primary: darkMode ? '#82B1FF' : '#2962FF',
            secondary: darkMode ? '#5C6BC0' : '#3F51B5',
            light: darkMode ? '#90CAF9' : '#64B5F6',
            dark: darkMode ? '#303F9F' : '#1A237E',
            // Motivating accent colors - carefully chosen for contrast and harmony
            success: darkMode ? '#81C784' : '#66BB6A',  // Soft green for achievements
            warning: darkMode ? '#FFB74D' : '#FFA726',  // Warm orange for coins/warnings
            error: darkMode ? '#E57373' : '#EF5350',    // Soft red for streaks/urgent
            // Achievement tiers - sophisticated and motivating
            bronze: darkMode ? '#A1887F' : '#8D6E63',   // Warm bronze
            silver: darkMode ? '#B0BEC5' : '#90A4AE',   // Cool silver
            gold: darkMode ? '#FFD54F' : '#FFCA28',     // Rich gold
            legendary: darkMode ? '#9FA8DA' : '#7986CB', // Premium blue-purple
            // Functional colors - themed consistently
            xp: darkMode ? '#82B1FF' : '#2962FF',       // Main theme blue
            coins: darkMode ? '#FFD54F' : '#FFCA28',    // Consistent gold
            streak: darkMode ? '#FF8A65' : '#FF7043',   // Warm motivating orange
        },
        divider: darkMode ? '#393B44' : '#E0E3EA',
        text: {
            primary: darkMode ? '#F3F6FB' : '#121212',
            secondary: darkMode
                ? 'rgba(243,246,251,0.7)'
                : 'rgba(18,18,18,0.7)',
            disabled: darkMode
                ? 'rgba(243,246,251,0.38)'
                : 'rgba(18,18,18,0.38)',
            hint: darkMode ? '#B2C3DF' : '#627797',
        },
        background: {
            default: darkMode ? '#1A1D23' : '#F5F7FA',
            paper: darkMode ? '#22262F' : '#FFFFFF',
            // Gamification backgrounds - blue-themed gradients
            gamification: darkMode ? 'linear-gradient(135deg, #82B1FF 0%, #5C6BC0 100%)' : 'linear-gradient(135deg, #2962FF 0%, #3F51B5 100%)',
            gamificationCard: darkMode ? 'linear-gradient(135deg, #303F9F 0%, #1A237E 100%)' : 'linear-gradient(135deg, #64B5F6 0%, #42A5F5 100%)',
        },
    };

    const themeOptions = {
        palette,
        shape: {
            borderRadius: 12,
        },

        typography: {
            fontFamily: [
                '"Inter"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
            ].join(','),
            fontWeightMedium: 600,
            h1: {fontWeight: 700},
            h2: {fontWeight: 700},
            h3: {fontWeight: 700},
            button: {textTransform: 'none', fontWeight: 600}
        },

        components: {
            MuiCard: {
                styleOverrides: {
                    root: {
                        borderRadius: 16,
                        transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                        '&:hover': {
                            transform: 'translateY(-2px)',
                        },
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: 12,
                        textTransform: 'none',
                        fontWeight: 600,
                        transition: 'all 0.2s ease-in-out',
                        '&:hover': {
                            transform: 'translateY(-1px)',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                    },
                },
            },
            MuiChip: {
                styleOverrides: {
                    root: {
                        fontWeight: 600,
                        transition: 'all 0.2s ease-in-out',
                        '&:hover': {
                            transform: 'scale(1.05)',
                        },
                    },
                },
            },
        }
    };

    return createTheme(themeOptions);
};

export default getTheme;
